import React, { useEffect, useState } from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { AppBar, Box, Container, makeStyles, Paper, Typography, useMediaQuery } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { ActivePoliciesList } from './ActivePolicies/ActivePoliciesList'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import Skeleton from '@material-ui/lab/Skeleton'
import { useRouteMatch, Switch, Route, useLocation, useHistory } from 'react-router-dom'
import { PolicyCardSkeleton } from './PolicyCardSkeleton'
import { isBrowser, MobileView } from 'react-device-detect'
import { SessionContextStore } from '../../context/SessionContext'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { SessionService } from '../../services/SessionService'
import BuyingInsuranceContext from '../../context/BuyingInsuranceContext'
import { BillingList } from './BillingList'
import PropTypes from 'prop-types'
import './PolicyManagmentLayout.scss'
import { ACTIONS, PolicyModificationContextStore } from '../../context/PolicyModificationContext'
import { Action } from '../../models/Action'
import { PolicyModificationSection } from './PolicyModification/PolicyModificationSection'
import { awaitWithLoading } from '../../services/utils.js'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  }
}

export const PolicyManagementLayout = () => {
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)
  const sessionContext = React.useContext(SessionContextStore)
  const modifyContext = React.useContext(PolicyModificationContextStore)
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const [tabIndex, setTabIndex] = React.useState(0)
  const [showRecipts, setShowRecipts] = React.useState(false)
  const location = useLocation()
  const history = useHistory()
  let { path, url } = useRouteMatch()
  const [isInModifyFlow, setIsInModifyFlow] = useState(true)

  const handleTabChange = (event, newValue) => {
    modifyContext.dispatch(new Action(ACTIONS.RESET))
    if (location.pathname != path) {
      history.replace(path)
    }
    setTabIndex(newValue)
  }

  useEffect(() => {
    if (location.pathname.includes('policy-management')) {
      history.replace(path)
    }
  }, [])

  useEffect(() => {
    if (modifyContext.is_modify_finish) {
      setIsInModifyFlow(false)
    } else {
      setIsInModifyFlow(true)
    }
  }, [modifyContext.is_modify_finish])

  useEffect(() => {
    const anyRoadSide = async () => {
      setShowRecipts(!(await awaitWithLoading(myPoliciesContext.anyRoadSidePolicies())))
    }
    anyRoadSide()
  }, [])

  React.useEffect(() => {
    if (!myPoliciesContext.loading_policies) {
      if (
        tabIndex == 0 &&
        myPoliciesContext.active_policies.length == 0 &&
        myPoliciesContext.pending_policies.length == 0 &&
        myPoliciesContext.scheduled_policies.length == 0 &&
        myPoliciesContext.expired_policies.length == 0 &&
        myPoliciesContext.canceled_policies.length == 0
      ) {
        if (myPoliciesContext.renewal_policies.length > 0) {
          handleTabChange(undefined, 1)
        }
      }
    }
  }, [myPoliciesContext.loading_policies])

  const showTabs = isBrowser || location.pathname == path

  return (
    <Container maxWidth={isMobile ? 'xs' : 'lg'} className="margin-top-basic">
      <FlexView hAlignContent={'left'} column={isMobile}>
        <React.Fragment>
          {isMobile && <div className="text-title textcenter black bold margin-top-basic">Policy management</div>}
          <div className={'root tabs-box margin-top-basic margin-bottom-basic'}>
            <AppBar position="relative" color="white" style={{ background: 'transparent', boxShadow: 'none' }}>
              <Tabs
                orientation={isMobile ? 'horizontal' : 'vertical'}
                variant="scrollable"
                value={tabIndex}
                indicatorColor={'primary'}
                textColor="primary"
                variant="scrollable"
                scrollButtons={isMobile ? 'on' : ''}
                onChange={handleTabChange}
              >
                <Tab label="Policy" {...a11yProps(0)} />
                <Tab label="Upcoming Renewal" {...a11yProps(1)} disabled={myPoliciesContext.renewal_policies.length == 0} />
                {<Tab label="Billing" {...a11yProps(2)} />}
              </Tabs>
            </AppBar>
          </div>
        </React.Fragment>

        <div className="full-width margin-left-basic margin-right-basic">
          {!isMobile && isInModifyFlow && (
            <FlexView vAlignContent={'bottom'}>
              <div className="text-title black bold margin-top-basic">Policy Management</div>
              {SessionService.isBroker() && (
                <div className="margin-top-basic text-tiny margin-left-6">
                  <BlueGrayBox>{sessionContext.user.email}</BlueGrayBox>
                </div>
              )}
            </FlexView>
          )}
          <Switch>
            <Route exact path={path}>
              {tabIndex == 0 && (
                <Container maxWidth="lg" className="active-poicy-padding">
                  {myPoliciesContext.loading_policies ? (
                    <FlexView column>
                      <PolicyCardSkeleton />
                      <PolicyCardSkeleton />
                    </FlexView>
                  ) : (
                    <ActivePoliciesList
                      policies={[
                        ...myPoliciesContext.active_policies,
                        ...myPoliciesContext.pending_policies,
                        ...myPoliciesContext.scheduled_policies,
                        ...myPoliciesContext.expired_policies,
                        ...myPoliciesContext.canceled_policies,
                      ]}
                    />
                  )}
                </Container>
              )}
              {tabIndex == 1 && (
                <Container maxWidth="lg">
                  {myPoliciesContext.loading_policies ? (
                    <PolicyCardSkeleton />
                  ) : (
                    <ActivePoliciesList policies={myPoliciesContext.renewal_policies} />
                  )}
                </Container>
              )}
              {tabIndex == 2 && (
                <Container maxWidth="lg">
                  <BillingList />
                </Container>
              )}
            </Route>
            <Route exact path={`${path}/:insuranceId`}>
              <MobileView>
                <div className="textcenter margin-bottom-small bold text-title blue capitalize">Hi {sessionContext.user.firstName},</div>
                <div className="textcenter text-body blue">Welcome to Motorcycle</div>
                <div className="textcenter text-body blue">Pay Per Mile Insurance!</div>
              </MobileView>
            </Route>
            <Route exact path={`${path}/:insuranceId/modify-policy`}>
              {SessionService.isAdmin() && <PolicyModificationSection />}
            </Route>
          </Switch>
        </div>
      </FlexView>
    </Container>
  )
}
